<template>
  <!-- <div class="data-import">
    <div class="second-menu">
      <ul class="menu-list">
        <router-link to="/data-import/step-guide" tag="li" active-class="active">步骤指南</router-link>
        <router-link to="/data-import/wms-order" tag="li" active-class="active">wms订单</router-link>
        <router-link to="/data-import/operating-income" tag="li" active-class="active">操作收入</router-link>
        <router-link to="/data-import/personnel-pay" tag="li" active-class="active">人员支出</router-link>
        <router-link to="/data-import/rental-income" tag="li" active-class="active">场租收入</router-link>
        <router-link to="/data-import/express-income" tag="li" active-class="active">预计快递</router-link>
        <router-link to="/data-import/income-expenditure" tag="li" active-class="active">实际快递</router-link>
        <router-link to="/data-import/expenses" tag="li" active-class="active">相关费用</router-link>
      </ul>
    </div>
  <div class="second-content">-->
  <router-view></router-view>
  <!-- <p class="copy">浙ICP备12004338号-5 | ©2020 杭州中仓供应链科技(集团)有限公司所有</p>
    </div>
  </div>-->
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.data-import {
  display: flex;
  height: 100%;
  .second-menu {
    width: 120px;
    background: #fff;
    .menu-list {
      li {
        height: 48px;
        font-size: 16px;
        color: #999999;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background: rgba(242, 244, 248, 1);
        color: #333333;
      }
    }
  }
  .second-content {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    background: #f2f4f8;
    padding: 16px;
    box-sizing: border-box;
    /* display: flex;
    flex-direction: column; */
    .copy {
      margin-top: 16px;
      font-size: 14px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>
